import { scrollToTop } from "../dom/smoothScroll";
import { track } from "../tracker/EventTracker";
import { pageType } from "@escapio/portal/state/pageType";

class ClickScroller extends HTMLElement {
	connectedCallback() {
		this.addEventListener("click", event => {
			event.stopPropagation();
			scrollToTop(document.querySelector(this.getAttribute("target")));
			const eventCategory = this.getAttribute("category");
			const eventAction = this.getAttribute("action");
			if (eventCategory && eventAction) {
				track(eventCategory, eventAction, pageType);
			}
		});
	}
}
customElements.define("esc-click-scroller", ClickScroller);
